import * as Yup from 'yup';

import i18n from '@/i18n';

export const createEditTextAssetSchema = Yup.object().shape({
  title: Yup.string()
    .required(i18n.t('titleTextRequired', { ns: 'common' }))
    .min(2, i18n.t('titleMin', { ns: 'common' }))
    .max(50, i18n.t('titleMax', { ns: 'common' })),
  description: Yup.string()
    .required(i18n.t('descriptionRequired', { ns: 'common' }))
    .min(2, i18n.t('descriptionMin', { ns: 'common' }))
});
